import React from 'react';

import LinksetField from '~fields/LinksetField';

const ICTLinksForm = () => {
  return <LinksetField name="links" />;
};

export default ICTLinksForm;
